import { AfterViewInit, Directive, ElementRef, OnDestroy, Output, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appAutoScroll]',
  standalone: true
})
export class AutoScrollDirective implements AfterViewInit, OnDestroy {
  private resizeObserver!: ResizeObserver;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngAfterViewInit(): void {
    const content = this.el.nativeElement;
    const container = content.closest('.mdc-dialog__surface');

    if (!container) return;

    this.adjustHeight(content, container);

    this.resizeObserver = new ResizeObserver(() => {
      this.adjustHeight(content, container);
    });

    this.resizeObserver.observe(container);
  }

  private adjustHeight(content: HTMLElement, container: HTMLElement): void {
    const header = container.querySelector('.contenedor_dialogo_cabecera') as HTMLElement | null;
    const footer = container.querySelector('mat-dialog-actions') as HTMLElement | null;
    const headerHeight = header?.offsetHeight || 0;
    const footerHeight = footer?.offsetHeight || 0;
    const containerHeight = container.offsetHeight;

    const availableHeight = containerHeight - headerHeight - footerHeight;
    this.renderer.setStyle(content, 'max-height', `${availableHeight}px`);
    this.renderer.setStyle(content, 'overflow-y', 'auto');
    this.renderer.setStyle(content, 'overflow-x', 'hidden');
  }

  ngOnDestroy(): void {
    this.resizeObserver?.disconnect();
  }
}
